import { colorsPalettes } from "@similarweb/styles";

import { translate } from "app/filters/i18nFilter";

import type { ITiersConfig } from "app/common/keyword-research/keywords-overview/serpCompositionTypes";

export const STATS_COMPOSITION_ENDPOINT = "api/KeywordAnalysis/Overview/Stats";
export const DEFAULT_SORT = "ClicksShare";

const { blue, midnight, sky } = colorsPalettes;

export const tiersConfig: ITiersConfig[] = [
    {
        get name() {
            return translate("keyword.analysis.overview.page.v2.serp_composition.classic_organic");
        },
        color: midnight[500],
        visible: true,
        id: "ClassicOrganic",
    },
    {
        get name() {
            return translate("keyword.analysis.overview.page.v2.serp_composition.organic_serp_features");
        },
        color: blue[500],
        visible: true,
        id: "OrganicSERPFeatures",
    },
    {
        get name() {
            return translate("keyword.analysis.overview.page.v2.serp_composition.search_ads");
        },
        color: blue[300],
        visible: true,
        id: "SearchAds",
    },
    {
        get name() {
            return translate("keyword.analysis.overview.page.v2.serp_composition.pla");
        },
        color: sky[200],
        visible: true,
        id: "PLA",
    },
];
